<div class="content">
  <div class="table-wrapper">
    <mat-table
      #table
      matSort
      matSortActive="departureCity"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource.delegationsMileages$ | async"
    >
      <ng-container matColumnDef="departureCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-DepartureCity' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.DepartureCity">
            {{ element.DepartureCity }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-StartDate' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.StartDate | date : 'yyyy-MM-dd'">
            {{ element.StartDate | date : 'yyyy-MM-dd' }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="destinationCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-DestinationCity' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.DestinationCity">
            {{ element.DestinationCity }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-EndDate' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.EndDate | date : 'yyyy-MM-dd'">
            {{ element.EndDate | date : 'yyyy-MM-dd' }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="delegationMileageTransportTypeName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-MileageTransportType' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.DelegationMileageTransportTypeName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="odometerBefore">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-OdometerBefore' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.OdometerBefore">
            {{ element.OdometerBefore }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="odometerAfter">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-OdometerAfter' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.OdometerAfter">
            {{ element.OdometerAfter }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="kilometersNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-KilometersNumber' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.KilometersNumber">
            {{ element.KilometersNumber }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="kilometerRate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-KilometersRate' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.KilometerRate">
            {{ element.KilometerRate }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="grossValue">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'DML-GrossValue' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.GrossValue">
            {{ element.GrossValue }}
          </app-copy>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>
          {{ 'Actions' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button id="delegation-mileage-list-details-button" mat-icon-button (click)="openDetailsModal(element)">
            <mat-icon>visibility</mat-icon>
          </button>

          @if (canEdit) {
          <button mat-icon-button id="delegation-mileage-list-delete-button" (click)="deleteDelegationMileage(element.DelegationId, element.DelegationCostId)">
            <mat-icon>delete</mat-icon>
          </button>
          } @if (canEdit) {
          <button mat-icon-button id="delegation-mileage-list-edit-button" (click)="openEditModal(element)">
            <mat-icon>edit</mat-icon>
          </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
</div>
